import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      redirect: '/home',
    },
    {
      path: '/halc',
      name: 'Hispanic American Leadership Council',
      component: () => import('../views/HomeView.vue'),
      meta: {
        title: 'Hispanic American Leadership Council',
        profile: 'halc',
      },
    },
    {
      path: '/home',
      name: 'Financial Independence Council',
      component: () => import('../views/HomeView.vue'),
      meta: {
        title: 'Financial Independence Council',
        profile: 'fic',
      },
    },

    {
      path: '/aalc',
      name: 'African American Leadership Council',
      component: () => import('../views/HomeView.vue'),
      meta: {
        title: 'African American Leadership Council',
        profile: 'aalc',
      },
    },
    {
      path: '/apilc',
      name: 'Asian Pacific Islanders Leadership Council',
      component: () => import('../views/HomeView.vue'),
      meta: {
        title: 'Asian Pacific Islanders Leadership Council',
        profile: 'apilc',
      },
    },
    {
      path: '/wip',
      name: 'Women In Primerica',
      component: () => import('../views/HomeView.vue'),
      meta: {
        title: 'Women In Primerica',
        profile: 'wip',
      },
    },
    /* {
      path: '/fic2',
      name: 'Financial Independence Council',
      component: () => import('../views/HomeView.vue'),
      meta: {
        title: 'Financial Independence Council',
        profile: 'fic',
      },
      children: [
        {
          path: 'halc',
          name: 'Hispanic American Leadership Council',
          component: () => import('../views/HomeView.vue'),
          meta: {
            title: 'Hispanic American Leadership Council',
            profile: 'halc',
          },
        },
        {
          path: 'aalc',
          name: 'Africian American Leadership Council',
          component: () => import('../views/HomeView.vue'),
          meta: {
            title: 'Africian American Leadership Council',
            profile: 'aalc',
          },
        },
        {
          path: 'apilc',
          name: 'Asian Pacific Islanders Leadership Council',
          component: () => import('../views/HomeView.vue'),
          meta: {
            title: 'Asian Pacific Islanders Leadership Council',
            profile: 'apilc',
          },
        },
        {
          path: 'wip',
          name: 'Women In Primerica',
          component: () => import('../views/HomeView.vue'),
          meta: {
            title: 'Women In Primerica',
            profile: 'wip',
          },
        },
        ],*/
  ],
});

export default router;
